var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.localShow || _vm.slots.toggle)?_c('span',[(_vm.slots.toggle)?_vm._t("toggle",null,null,{
      on: {
        click: function () { return (_vm.localShow = !_vm.localShow); },
      },
      bind: {
        type: 'button',
        role: 'button',
        'aria-haspopup': true,
        'aria-expanded': '' + _vm.localShow,
      },
    }):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":_vm.bgTransition || _vm.transition,"appear":""}},[(_vm.localShow)?[_c('div',{class:['vts-drawer', _vm.classes.root, _vm.classes.bg, _vm.$attrs.class]},[_c('transition',{attrs:{"name":_vm.transition,"appear":""}},[(_vm.localShow)?_c(_vm.tag,{ref:"content",tag:"component",class:[
              'vts-drawer__content',
              { 'vts-drawer__content--right': !!_vm.right },
              _vm.classes.content ],style:({
              width: _vm.width,
              'inline-size': _vm.inlineSize,
              'max-width': _vm.maxWidth,
              'max-inline-size': _vm.maxInlineSize,
            }),attrs:{"tabindex":"-1"}},[_vm._t("default")],2):_vm._e()],1)],1)]:_vm._e()],2)],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }